import * as React from "react";

import Grid, { GridSize } from "@mui/material/Grid";
import type { SxProps } from "@mui/material/styles";

type PatientReviewDetailGroupProps = {
  children?: React.ReactNode;
  value?: object;
  sx?: SxProps;
  xs?: boolean | GridSize;
  sm?: boolean | GridSize;
  md?: boolean | GridSize;
  lg?: boolean | GridSize;
  testId: string;
};

export default function PatientReviewDetailGroup({
  children,
  value,
  testId,
  sx = { pb: 2 },
  xs = 12,
  sm = 12,
  md = 6,
  lg = 3
}: PatientReviewDetailGroupProps) {
  return (
    <Grid item container spacing={3} sm={12} sx={sx}>
      <Grid item container sm={12} data-testid={testId}>
        {children}
      </Grid>
    </Grid>
  );
}
